import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchBalanceModificationTransactionsDelete from '../../api/BalanceModificationTransactionsDeleteAPI';
import { BOH_TRANSACTIONS_DELETE_REQUEST } from '../actions/types/BalanceModificationTransactionsDeleteActionsTypes';
import {
  deleteBalanceModificationTransactionsDeleteSuccessActionCreator,
  deleteBalanceModificationTransactionsDeleteFailureActionCreator,
} from '../actions/BalanceModificationTransactionsDeleteActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doBohTransactionsDeleteWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchBalanceModificationTransactionsDelete, action.payload);
    yield put(deleteBalanceModificationTransactionsDeleteSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.bohtransaction.delete.success'),
    }));
  } catch (error) {
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.bohtransaction.delete.fail'),
    }));
    yield put(deleteBalanceModificationTransactionsDeleteFailureActionCreator(error));
  }
}

function* doBohTransactionsDeleteWatcher() {
  yield takeLatest(BOH_TRANSACTIONS_DELETE_REQUEST, doBohTransactionsDeleteWorker);
}

export default doBohTransactionsDeleteWatcher;
